<template>
	<div class="tabMail">
		<div class="fieldGroup">
			<div class="fieldTitle">Map keys</div>
			<div class="groupFieldTitle">
				<span>Emails</span>
				<button
						type="button"
						@click="onAddItem"
						:disabled="!permissions[tabPermissionId][8]"
				>
					<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
				</button>
			</div>
			<div class="warning_block">
				<svg-sprite width="20" height="20" icon-id="warning"></svg-sprite>
				<span>Default emails for “Trucks on the road” report</span>
			</div>
			<template v-for="(item, idx) in emails">
				<div class="groupField_wrap" :key="idx">
					<field
							:classError="getError(idx)"
							margin="0 0 10px 0"
							width="346px"
							label="Email"
							placeholder="Select email"
							@updateInput="onInput($event, item.id)"
							:setInputValue="item.value"
							:idx="idx"
							is-required
							:isReadonly="!permissions[tabPermissionId][9]"
					></field>
					<button type="button"
					        class="deleteItem"
					        @click="onDeleteItem(idx)"
					        :disabled="permissionsDelete()"
					>
						<svg-sprite width="20" height="20" icon-id="deleteItem"></svg-sprite>
					</button>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
import Field from "@/shared/Field/Field";
import { mapGetters } from "vuex";

export default {
	name: "TrucksOnTheRoad",
	components: {
		Field
	},
	props: {
		valid: Object,
		emails: Array,
		tabPermissionId: Number
	},
	computed: {
		...mapGetters([
			'getTabPermission',
		]),
		permissions() {
			return this.getTabPermission;
		},
	},
	methods: {
		permissionsDelete() {
			if (this.permissions[this.tabPermissionId][11]) {
				if (this.emails.length === 1) return true;
				return false;
			}
			return true;
		},
		getError(idx) {
			return this.valid.trucksOnTheRoadEmailsList?.$each?.$iter[idx]?.value?.$error;
		},
		onInput(value) {
			this.$emit('updateTrucksOnTheRoadEmailEdit', value);
		},
		onAddItem() {
			const value = { id: null, value: null };
			this.$emit('updateTrucksOnTheRoadEmailList', { item: value });
		},
		onDeleteItem(idx) {
			this.$emit('updateTrucksOnTheRoadEmailDelete', idx);
		},
	}
};
</script>

<style scoped lang="scss">
.warning_block {
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #F49741;
	display: flex;
	align-items: center;
	margin-bottom: 10px;

	span {
		margin-left: 10px;
		display: inline-block;
	}
}

.switch {
	margin-bottom: 20px;
}

.deleteItem {
	margin-left: 20px;
	color: #19BC38;

	&[disabled] {
		cursor: default;
		color: rgba(255, 255, 255, 0.6);
	}
}

.groupField {
	background: #1C1C28;
	width: 100%;
	max-width: 560px;

	&Title {
		margin-bottom: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: #8F90A6;
		width: 100%;
		display: flex;
		justify-content: space-between;

		button {
			height: 20px;
			color: #19BC38;

			&[disabled] {
				cursor: default;
				color: rgba(255, 255, 255, 0.6);
			}
		}
	}

	&_wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
}
</style>
